import Head from 'next/head';
import Image from 'next/image';
import Link from 'next/link';
import Script from 'next/script';
import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { prescriptionData } from '../../assets/data';
import {
  mental3,
  mental4,
  mental5,
  mentalHero,
  mentalHeroElement,
  mentalType1,
} from '../../assets/images';
import { TrustBoxWide } from '../../components/trustBox';
const MentalHealth = () => {
  const [CurrentCondition, setCurrentCondition] = useState(0);
  // function changeCondition() {
  //   let dot = document.getElementById(CurrentCondition)
  //   let title = document.getElementById(prescriptionData[CurrentCondition].title)
  //   dot.
  // }
  return (
    <div className='containerMental'>
      {' '}
      <Script
        type='text/javascript'
        src='//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js'
        strategy='lazyOnload'
      />
      <Head>
        <title>Online Mental Health Counseling & Medications - 24hrdoc</title>
        <meta
          name='description'
          content='Get online mental health treatment at 24hrdoc. Consult a doctor for anxiety, depression, or ADHD and get a prescription if needed. Fast, affordable care.'
        />
        <meta
          name='keywords'
          content='mental health treatment online,online mental health counseling,online mental health medication,virtual mental health treatment,'
        />
        <meta
          property='og:image'
          content='https://www.24hrdoc.com/_next/image?url=%2Fassets%2Ficons%2FLogoTransparent.png&w=384&q=75'
        />
        <meta name='robots' content='noindex,nofollow' />
        <link rel='canonical' href='https://www.24hrdoc.com/mental-health' />
      </Head>
      <article>
        <Container fluid className='firstRowContainer'>
          <Row
            className='row-1-std rowMental'
            style={{ position: 'relative', backgroundColor: '#ECFAF6' }}
          >
            <img
              className='bgArrowHero'
              src={mentalHeroElement}
              alt='Ui element'
            />
            <Col xs={12} sm={6} className='col1'>
              <section>
                <h1>Holistic Mental Health Treatments</h1>
                <h2>Mental Health</h2>
                <p>
                  Unlock quality mental health consultation and medication
                  service at 24HrDOC, your gateway to online mental health
                  treatment. Explore our online mental health counseling
                  services from certified professionals.
                </p>
                <a href='#types'>
                  {' '}
                  <button className='btnTreatment mb-4'>Start Treatment</button>
                </a>
              </section>
            </Col>
            <Col xs={12} sm={6} className='col2'>
              <div className='drContainerMental'>
                <Image
                  src={mentalHero}
                  className='dr1-image'
                  width={578}
                  height={578}
                  layout='responsive'
                  objectFit='contain'
                  style={{ position: 'absolute' }}
                  alt='online doctor for mental health treatments'
                />
              </div>
            </Col>
          </Row>
          <section
            style={{ position: 'relative', overflow: 'hidden' }}
            id='types'
          >
            <Row className='rowTypesMental'>
              <h2 id='treatments'>Types of Mental Illnesses</h2>
              <Col xs={12} sm={7}>
                <Row>
                  <div className='dotColumn'>
                    {prescriptionData.map((m, index) => (
                      <div
                        key={index}
                        id={m.title}
                        className={
                          index == CurrentCondition
                            ? 'greenDotEngorged'
                            : 'greenDot'
                        }
                        onClick={() => setCurrentCondition(index)}
                      ></div>
                    ))}
                  </div>
                  <Col xs={4} sm={3} className='titleColumn'>
                    {prescriptionData.map((m, index) => (
                      <div
                        key={index}
                        className={
                          index == CurrentCondition ? 'titleEngorged' : 'title'
                        }
                        onClick={() => setCurrentCondition(index)}
                      >
                        {m.title}
                      </div>
                    ))}
                  </Col>
                  <Col xs={8}>
                    <div className='text'>
                      <div className='description'>
                        <h3>Description</h3>
                        <p>{prescriptionData[CurrentCondition].description}</p>
                      </div>
                      <div className='symptoms'>
                        <h3>Symptoms</h3>
                        <p>
                          {prescriptionData[CurrentCondition].symptoms.map(
                            (s, i) => (
                              <li key={i}>{s}</li>
                            )
                          )}
                        </p>
                      </div>
                      <div className='treatment'>
                        <h3>Treatment</h3>
                        <p>{prescriptionData[CurrentCondition].treatment}</p>
                      </div>
                      <Link
                        href={`/diagnosis?diseaseID=${prescriptionData[CurrentCondition].id}`}
                      >
                        <button className='btnTreatment'>
                          Start Treatment for $
                          {prescriptionData[CurrentCondition].price}
                        </button>
                      </Link>
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col
                xs={12}
                sm={5}
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <div className='typesImageContainer'>
                  <Image
                    src={mentalType1}
                    width={578}
                    height={578}
                    layout='responsive'
                    objectFit='contain'
                    style={{ position: 'absolute' }}
                    alt='online doctor for mental health treatments'
                  />
                </div>
              </Col>
            </Row>
          </section>
          <section>
            {' '}
            <Row className='rowMental3'>
              <Col className='col1' xs={12} sm={5}>
                <div className='imageContainer'>
                  {' '}
                  <Image
                    src={mental3}
                    className='dr1-image'
                    width={1200}
                    height={1200}
                    layout='responsive'
                    objectFit='contain'
                    style={{ position: 'absolute' }}
                    alt='online doctor for mental health treatments'
                  />
                </div>
              </Col>
              <Col xs={12} sm={7} className='col2'>
                <h3>
                  Access Online Mental Health Testing and Treatment Options
                </h3>
                <p>
                  Online therapy makes it easier for individuals to take charge
                  of their mental health and get treatment in a way that fits
                  their lives and budgets. 24HrDOC is a platform that helps you
                  connect to a therapist, psychologist, or psychiatrist who fits
                  your needs and lets you schedule your appointments according
                  to your comfort.
                </p>

                <ul style={{ color: 'white' }}>
                  <li>Access professional support on the go</li>
                  <li>
                    Have one-on-one conversations with highly qualified
                    counselors{' '}
                  </li>
                  <li>Get unparalleled support and assistance </li>
                  <li>
                    Easy access to the right medication at your local pharmacy{' '}
                  </li>
                  <li>
                    Seek online therapy to overcome insomnia, anxiety,
                    depression, stress, and more
                  </li>
                </ul>
                <a href='#types'>
                  {' '}
                  <button>Get Treated Now</button>
                </a>
              </Col>
            </Row>
          </section>{' '}
          <section style={{ position: 'relative', overflow: 'hidden' }}>
            <Row className='rowMental4'>
              <Col xs={12} sm={7} className='col1'>
                <h2 id='treatments'>How It Works</h2>
                <p s>
                  24hrDOC provides exceptional professional care, personalized
                  counseling, prescription medication from certified
                  professionals, and unwavering support for you to reach your
                  mental health goals. Experience peace of mind from the comfort
                  of your home.
                </p>
                <h3>1 - Complete Consultation Form</h3>
                <p>
                  Let us know your mental health condition, symptoms and history
                </p>
                <h3>2 - Receive 1-On-1 Care</h3>
                <p>
                  Receive timely mental health advice and a treatment plan from
                  expert doctors in just hours
                </p>
                <h3>3 - Pharmacy Receives Prescription</h3>
                <p>
                  Convenient prescriptions- ready to pick up at a local pharmacy
                  near you
                </p>
              </Col>
              <Col
                xs={12}
                sm={5}
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <div className='typesImageContainer'>
                  <Image
                    src={mental4}
                    width={960}
                    height={960}
                    layout='responsive'
                    objectFit='contain'
                    style={{ position: 'absolute' }}
                    alt='online doctor for mental health treatments'
                  />
                </div>
              </Col>
            </Row>
          </section>
          <section>
            {' '}
            <Row className='rowMental5'>
              <Col className='col1' xs={12} md={5}>
                <div className='imageContainer'>
                  {' '}
                  <Image
                    src={mental5}
                    className='dr1-image'
                    width={1200}
                    height={1200}
                    layout='responsive'
                    objectFit='contain'
                    style={{ position: 'absolute' }}
                    alt='online doctor for mental health treatments'
                  />
                </div>
              </Col>
              <Col xs={12} md={7} className='col2'>
                <h3>More on mental illness</h3>
                <p>
                  At 24HrDOC, we are dedicated to providing comprehensive
                  virtual mental health care experience, round the clock. We
                  have partnered with multiple experts to provide an extensive
                  suite of remote mental health services, tailored to meet very
                  specific needs. In three simple steps, you can get access to
                  personalized care and mental health support from certified
                  professionals within hours.
                </p>

                <p>
                  Our platform is designed for ease of access and lets you
                  communicate in your preferred mode of communication. 24HrDOC
                  aims to improve your mental well-being and provide you
                  unparalleled support, privacy, and convenience throughout your
                  mental health journey.
                </p>
                <a href='#types'>
                  {' '}
                  <button>Get Treated Now</button>
                </a>
              </Col>
            </Row>
          </section>{' '}
          <section>
            <Row className='lastRow'>
              <div className='textContent'>
                {' '}
                <h2>Discreet, Caring, Understanding and Non-Judgmental</h2>
                <p
                  style={{
                    fontSize: '18px',
                    color: '#9FACC8',
                    textAlign: 'center',
                    margin: '2rem 0',
                  }}
                >
                  A healthy mental state helps you take charge of your life and
                  empowers you to propel towards your goals without hindrances.
                  With 24HrDOC, you can discuss your mental health symptoms
                  confidentially in the comfort of your home and get prompt and
                  effective treatment.
                </p>
                <h2>Newsletter</h2>
                <p
                  style={{
                    fontSize: '18px',
                    color: '#9FACC8',
                    textAlign: 'center',
                    margin: '2rem 0',
                  }}
                >
                  Be the first one to know about discounts, offers and events
                  weekly in your mailbox. Unsubscribe whenever you like with one
                  click.
                </p>
                <div className='emailBox'>
                  <input type='email' placeholder='Enter your email' />
                  <button>Submit</button>
                </div>
              </div>
            </Row>
          </section>
          <TrustBoxWide />
        </Container>
      </article>
    </div>
  );
};

export default MentalHealth;
